export default [
  {
    value0: 'Control manual',
    value1: 'Control automático',
  },
  {
    value0: 'Control ejecutado por la misma persona que ejecuta la acción en la que se produce el riesgo',
    value1: 'Control ejecutado por una persona diferente a la que ejecuta la acción en la que se produce el riesgo',
  },
  {
    value0: 'Control no auditado',
    value1: 'Control auditado',
  },
  {
    value0: 'Control no procedimentado',
    value1: 'Control procedimentado',
  },
  {
    value0: 'Control puntual',
    value1: 'Control recurrente, regular',
  },
  {
    value0: 'Control detectivo',
    value1: 'Control preventivo',
  },
];
